{
  "account.copy": "Copy",
  "account.created.claudeCode": "Claude Code",
  "account.created.done": "Done",
  "account.created.json": "Clients configured with JSON (for example a project's .mcp.json)",
  "account.created.once": "Copy the token now. It is shown only this once; KSS keeps only a fingerprint of it.",
  "account.created.title": "Token “{name}”",
  "account.expiry.1y": "a year",
  "account.expiry.30d": "30 days",
  "account.expiry.90d": "90 days",
  "account.expiry.never": "never expires",
  "account.mcp": "MCP connector",
  "account.mcp.address": "Connector address:",
  "account.mcp.disabled": "An administrator has switched the MCP connector off.",
  "account.mcp.sub": "Let an AI assistant work with KSS on your behalf. It can do what you can, within the limits of its token.",
  "account.refused.admin_only": "Only administrators can create a token with server administration.",
  "account.refused.disabled": "The MCP connector is switched off.",
  "account.refused.expiry": "Choose when the token expires.",
  "account.refused.name": "Give the token a name.",
  "account.refused.rights": "These rights do not exist.",
  "account.refused.too_many": "You already have as many tokens as allowed. Revoke one first.",
  "account.refused.workspace": "Choose only workspaces you belong to.",
  "account.rights.admin": "Read, write and server administration",
  "account.rights.read": "Read",
  "account.rights.write": "Read and write",
  "account.title": "Account",
  "account.tokens": "Tokens",
  "account.tokens.allWorkspaces": "all workspaces",
  "account.tokens.allWorkspacesLong": "All my workspaces, including ones I join later",
  "account.tokens.create": "Create token",
  "account.tokens.expires": "expires {date}",
  "account.tokens.expiry": "Expires after",
  "account.tokens.lastUsed": "last used {date}",
  "account.tokens.name": "Name",
  "account.tokens.namePlaceholder": "e.g. Claude on my laptop",
  "account.tokens.never": "never",
  "account.tokens.new": "New token…",
  "account.tokens.none": "No tokens yet.",
  "account.tokens.notYet": "not yet",
  "account.tokens.revoke": "Revoke",
  "account.tokens.revoked": {
    "one": "{count} revoked token",
    "other": "{count} revoked tokens"
  },
  "account.tokens.rights": "Rights",
  "account.tokens.workspaces": "Workspaces",
  "app.account": "Your account and MCP tokens",
  "app.handbook": "Handbook",
  "app.help": "Help for this page",
  "app.language": "Interface language",
  "app.logOut": "Log out",
  "auth.adminOnly": "Only administrators can sign in with a password here.",
  "auth.adminSignIn": "Administrator sign-in",
  "auth.error.failed": "Signing in did not complete. Please try again.",
  "auth.error.group": "Your account is not permitted to use KSS. Ask an administrator for access.",
  "auth.error.unavailable": "The sign-in service is not reachable right now.",
  "auth.invalid": "Invalid credentials.",
  "auth.orLocal": "or with a local account",
  "auth.password": "Password",
  "auth.passwordDisabled": "Password sign-in is disabled.",
  "auth.signIn": "Sign in to the Knowledge Storage System",
  "auth.submit": "Sign in",
  "auth.username": "Username",
  "auth.withProvider": "Sign in with {provider}",
  "block.add": "Add block",
  "block.copied": {
    "one": "Copied {count} block",
    "other": "Copied {count} blocks"
  },
  "block.drag": "Drag block",
  "block.drag.title": "Drag to move · Ctrl/⌘-click to select",
  "block.drag.titleReadOnly": "Ctrl/⌘-click to select",
  "block.emptyPage": "Empty page.",
  "block.issues.dangling_link": "dangling link",
  "block.issues.deprecated_term": "deprecated term",
  "block.issues.derived_edge": "suggested edge",
  "block.issues.grounding": "grounding question",
  "block.issues.lww_conflict": "conflicting edit",
  "block.issues.shacl_violation": "shape violation",
  "block.menu": "Block menu",
  "block.menu.copy": "Copy",
  "block.menu.copyIri": "Copy block IRI",
  "block.menu.copyN": "Copy {count} blocks",
  "block.menu.delete": "Delete",
  "block.menu.detach": "Detach (make a copy)",
  "block.menu.down": "Move down",
  "block.menu.intoGroup": "Move into group above",
  "block.menu.link": "Link…",
  "block.menu.links": "Links…",
  "block.menu.openOriginal": "Open original",
  "block.menu.outOfGroup": "Move out of group",
  "block.menu.pasteAfter": "Paste after…",
  "block.menu.pasteInto": "Paste into group…",
  "block.menu.role": "Set role…",
  "block.menu.sequence": "Add to sequence…",
  "block.menu.untitledSequence": "(untitled)",
  "block.menu.up": "Move up",
  "block.mirror.confirmDelete": "This deletes the block from “{source}” and from every mirror of it.",
  "block.mirror.unavailable": "The original is not available, so the mirror cannot be detached.",
  "block.none": "No blocks.",
  "block.paste": "Paste",
  "block.resize": "Resize block",
  "block.resize.title": "Drag to resize · double-click to reset",
  "block.type.audio": "Audio",
  "block.type.checklist": "Checklist",
  "block.type.chemistry": "Chemical structure",
  "block.type.code": "Code",
  "block.type.externalVideo": "External video",
  "block.type.file": "File",
  "block.type.graphView": "Graph view",
  "block.type.group": "Group",
  "block.type.image": "Image",
  "block.type.mermaid": "Mermaid diagram",
  "block.type.mirror": "Mirror",
  "block.type.pageLink": "Link to a page",
  "block.type.reaction": "Reaction",
  "block.type.section": "Text section",
  "block.type.table": "Table",
  "block.type.url": "URL",
  "block.type.video": "Video",
  "block.type.webpage": "Web page",
  "checklist.add": "Add item",
  "checklist.delete": "Delete item",
  "checklist.done": "Done",
  "checklist.drag": "Drag item",
  "checklist.hideDone": "hide completed",
  "checklist.progress": "{done} / {total} done",
  "checklist.title": "Checklist",
  "checklist.todo": "To do",
  "chem.changedRemotely": "Changed remotely",
  "chem.edit": "Edit",
  "chem.empty": "No structure yet.",
  "chem.emptyEdit": "No structure yet — click Edit to draw one.",
  "chem.kind.molecule": "molecule",
  "chem.kind.reaction": "reaction",
  "chem.loading": "Loading Ketcher…",
  "chem.needArrow": "Draw a reaction arrow first: a reaction block saves reactions only.",
  "chem.overwrite": "Overwrite with mine",
  "chem.reloadRemote": "Reload remote",
  "chem.title.reaction": "Reaction",
  "chem.title.structure": "Chemical structure",
  "code.label": "code",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.done": "Done",
  "common.edit": "edit",
  "common.label": "Label",
  "common.loading": "Loading…",
  "common.remove": "remove",
  "common.removeEntry": "Remove",
  "common.save": "Save",
  "concepts.delete": "Delete concept",
  "concepts.empty": "No workspace concepts yet.",
  "concepts.new": "New concept",
  "concepts.title": "Concepts",
  "delete.body": "The page moves to the workspace's trash, where it can be restored. Links from other pages to its blocks are reported as dangling in the review inbox until it comes back. Nothing is purged: its history and files are kept.",
  "delete.dialog": "Delete page",
  "delete.heading": "Delete “{title}”?",
  "export.button": "Export…",
  "export.notes": {
    "one": "{count} note in the archive's manifest.",
    "other": "{count} notes in the archive's manifest."
  },
  "export.offline": "Export needs the server",
  "export.preparing": "Preparing archive…",
  "export.title": "Export this page and its files as a .kss.zip archive",
  "export.unsynced": "Unsynced changes are not included.",
  "extract.failed": "failed",
  "extract.failedWith": "failed: {error}",
  "extract.progress": "extracting {done}/{total}…",
  "extract.run": "Extract",
  "extract.title": "Extract knowledge-graph candidates from this page with the LLM",
  "extract.triples": {
    "one": "{count} candidate triple",
    "other": "{count} candidate triples"
  },
  "file.download": "download",
  "file.downloadButton": "Download",
  "file.inA": "in a",
  "file.inline": "open in the browser",
  "file.name": "file",
  "file.newTab": "new tab",
  "file.newWindow": "new window",
  "file.offline": "not available offline",
  "file.open": "Open",
  "file.unknownType": "unknown type",
  "file.whenOpened": "When opened",
  "graph.autoCentre": "Auto-centre on re-run",
  "graph.blockTitle": "Graph view",
  "graph.builder.error": "The query builder could not be loaded. The SPARQL editor below still works.",
  "graph.builder.loading": "Loading the query builder…",
  "graph.builder.open": "Build a query",
  "graph.builder.openBlock": "Build query…",
  "graph.builder.use": "Use query",
  "graph.choosePage": "Choose a page…",
  "graph.fit": "Fit graph",
  "graph.graphView": "graph view",
  "graph.groupByPage": "group by page",
  "graph.hideDerived": "hide derived duplicates",
  "graph.insertPrefixes": "Insert prefixes",
  "graph.layout.elk": "ELK layered",
  "graph.layout.preset": "preset",
  "graph.nodes": {
    "one": "{count} node",
    "other": "{count} nodes"
  },
  "graph.rows": {
    "one": "{count} row",
    "other": "{count} rows"
  },
  "graph.run": "Run",
  "graph.runHint": "Ctrl/⌘-Enter runs",
  "graph.running": "running…",
  "graph.saveAsBlock": "Save as block",
  "graph.staleSince": "stale since {time}",
  "graph.tableView": "table view",
  "graph.template.annotations": "Annotations on a block",
  "graph.template.blocksByPage": "All blocks and their pages",
  "graph.template.chebi": "Blocks mentioning a chemical entity (ChEBI subclasses)",
  "graph.template.derivedPending": "Derived edges pending review",
  "graph.template.inchikeys": "Structures and participants by InChIKey",
  "graph.template.neighbourhood": "Neighbourhood of a block",
  "graph.template.pageLinks": "All links of a page",
  "graph.template.sequences": "Members of sequences",
  "graph.templates": "Templates",
  "graph.toggleEditor": "Toggle query editor",
  "graph.tooLarge": "large result: table view",
  "graph.truncated": "truncated",
  "graph.typeEdges": "type edges",
  "graph.zoom": "Zoom",
  "graph.zoomIn": "Zoom in",
  "graph.zoomOut": "Zoom out",
  "group.collapse": "Collapse group",
  "group.expand": "Expand group",
  "group.title": "Group title",
  "image.alt": "Alt text",
  "import.blocks": {
    "one": "{count} block",
    "other": "{count} blocks"
  },
  "import.button": "Import page…",
  "import.files": {
    "one": "{count} file",
    "other": "{count} files"
  },
  "import.importing": "Importing…",
  "import.links": {
    "one": "{count} workspace link",
    "other": "{count} workspace links"
  },
  "import.offline": "Import needs the server",
  "import.open": "Open page",
  "import.refused": "Import refused: {error}",
  "import.sequences": {
    "one": "{count} sequence",
    "other": "{count} sequences"
  },
  "import.summary": "Imported “{title}”: {blocks}, {files}; concepts: {matched} matched, {created} created; {sequences}, {links}.",
  "import.title": "Import a page exported from KSS (.kss.zip) as a new page",
  "import.tooLarge": "the archive is too large",
  "import.uploadFailed": "the upload failed",
  "import.uploading": "Uploading… {percent} %",
  "inspector.copyIri": "Copy IRI",
  "inspector.edges": "Edges ({count})",
  "inspector.empty": "Select a node to inspect it. Double-click expands its neighbours.",
  "inspector.expand": "Expand",
  "inspector.open": "Open",
  "inspector.properties": "Properties",
  "inspector.stale": "stale",
  "inspector.style": "style {style}",
  "inspector.types": "Types",
  "inspector.variables": "Result variables",
  "linkDialog.add": "Add link",
  "linkDialog.chooseTarget": "Choose a target",
  "linkDialog.datatype": "Datatype",
  "linkDialog.deprecated": "deprecated",
  "linkDialog.noConcepts": "No workspace concepts yet — create one in the workspace sidebar.",
  "linkDialog.note": "Note (optional)",
  "linkDialog.only": "only {class} terms",
  "linkDialog.otherIri": "Other IRI…",
  "linkDialog.page": "page",
  "linkDialog.predicate": "Predicate",
  "linkDialog.search": "Search…",
  "linkDialog.tab.blocks": "Blocks",
  "linkDialog.tab.concepts": "Concepts",
  "linkDialog.tab.iri": "IRI",
  "linkDialog.tab.literal": "Value",
  "linkDialog.tab.terms": "Ontology terms",
  "linkDialog.takesType": "This predicate takes a value of type {type}.",
  "linkDialog.target": "Target",
  "linkDialog.title": "Link this block",
  "linkDialog.unconstrained": "Not constrained by any shape: this predicate is outside the imported ontologies.",
  "linkDialog.valueNotLink": "A value rather than a link to something.",
  "linkDialog.workspaceConcept": "workspace concept",
  "links.close": "close",
  "links.facts": "Facts",
  "links.facts.about": "About (optional)",
  "links.facts.aboutLabel": "about {term}",
  "links.facts.add": "Add fact",
  "links.facts.kind": "Kind",
  "links.facts.lead": "Values stated about this block.",
  "links.facts.noKind": "(no kind)",
  "links.facts.note": "Note",
  "links.facts.remove": "Remove fact",
  "links.facts.unit": "Unit",
  "links.facts.value": "Value",
  "links.from": "from {source}",
  "links.group.alternatives": "Alternatives",
  "links.group.any": "any combination",
  "links.group.atLeastOne": "at least one",
  "links.group.cancel": "cancel",
  "links.group.choose": "Choose this option",
  "links.group.create": {
    "one": "Group {count} link",
    "other": "Group {count} links"
  },
  "links.group.custom": "between n and m…",
  "links.group.dissolve": "dissolve",
  "links.group.exactlyN": "exactly {n}",
  "links.group.exactlyOne": "exactly one",
  "links.group.labelPlaceholder": "Label (optional), e.g. Storage backend",
  "links.group.orMore": "{min} or more",
  "links.group.range": "{min} to {max}",
  "links.group.takeOut": "Take out of the group",
  "links.group.tooMany": "too many chosen",
  "links.group.ungroup": "ungroup",
  "links.groupAsAlternatives": "Group as alternatives…",
  "links.incoming": "Incoming",
  "links.incomingNeedServer": "Offline — incoming links need the server.",
  "links.none": "No links yet.",
  "links.noneShort": "None.",
  "links.outgoing": "Outgoing",
  "links.promoted": "promoted from extraction",
  "links.prov.asserted": "asserted",
  "links.prov.computed": "computed",
  "links.prov.derived": "derived",
  "links.prov.ontology": "ontology",
  "links.remove": "Remove link",
  "links.select": "Select link",
  "links.short.block": "block {id}",
  "links.short.concept": "concept {id}",
  "links.short.page": "page",
  "links.title": "Links",
  "literal.aValue": "a value",
  "literal.needLang": "a language tag is needed, e.g. en or de",
  "literal.needValue": "a value is needed",
  "literal.not.boolean": "not a boolean",
  "literal.not.date": "not a date",
  "literal.not.dateTime": "not a date and time",
  "literal.not.decimal": "not a decimal",
  "literal.not.integer": "not an integer",
  "literal.notDate": "not a real date",
  "literal.notUri": "not a URI",
  "literal.type.boolean": "boolean",
  "literal.type.date": "date",
  "literal.type.dateTime": "date and time",
  "literal.type.decimal": "decimal",
  "literal.type.integer": "integer",
  "literal.type.langString": "text with a language",
  "literal.type.string": "string",
  "literal.type.text": "text",
  "literal.type.uri": "URI",
  "media.caption": "Caption",
  "media.choose": "choose a file",
  "media.drop": "Drop a file here or",
  "media.hashing": "hashing… {percent}%",
  "media.none": "No media",
  "media.offline": "{name} (not available offline)",
  "media.replace": "replace",
  "media.uploadFailed": "upload failed: {error}",
  "media.uploadState.queued": "queued… {percent}%",
  "media.uploadState.uploading": "uploading… {percent}%",
  "mermaid.hideSource": "hide source",
  "mermaid.showSource": "show source",
  "mirror.blockOn": "a block on “{title}”",
  "mirror.deleted": "The original was deleted.",
  "mirror.forbidden": "You cannot read the original.",
  "mirror.loop": "Mirror loop: this mirror shows itself.",
  "mirror.noOriginal": "This mirror has no original.",
  "mirror.of": "Mirror of",
  "mirror.offline": "The original is not available offline.",
  "mirror.otherWorkspace": "The original is not in this workspace.",
  "mirror.page": "“{title}”",
  "mirror.tooDeep": "Mirrors are nested too deeply to show here.",
  "offline.caching": "caching…",
  "offline.cachingProgress": "caching {done}/{total}",
  "offline.pin": "pin",
  "offline.pinned": "offline",
  "offline.title": "Available offline",
  "page.backToWorkspace": "← Workspace",
  "page.copied": "Copied",
  "page.copyAll": "Copy all blocks",
  "page.copyAll.title": "Copy every block of this page (paste as a copy, a mirror or an empty structure)",
  "page.opening": "Opening page…",
  "page.titlePlaceholder": "Untitled page",
  "page.untitled": "Untitled",
  "page.width": "Page width",
  "page.width.full": "Full width",
  "page.width.narrow": "Narrow",
  "page.width.wide": "Wide",
  "pageActions.delete": "Delete page…",
  "pageActions.delete.readOnly": "You cannot write this page",
  "pageActions.linkPage": "Link page…",
  "pageActions.menu": "Page actions",
  "pageActions.restrict": "Restrict writing…",
  "pageActions.restrict.ownerOnly": "Only an owner can restrict writing",
  "pageLink.change": "Choose page…",
  "pageLink.missing": "The page no longer exists, or you cannot read it.",
  "pageLink.noMatch": "No page matches.",
  "pageLink.none": "No page chosen yet.",
  "pageLink.offline": "Offline — the page list needs the server.",
  "pageLink.search": "Search pages…",
  "pageLink.trashed": "“{title}” is in the trash.",
  "paste.dialog": "Paste blocks",
  "paste.mode.copy": "Copy contents",
  "paste.mode.copyHint": "Independent blocks with the same content; editing them leaves the originals alone.",
  "paste.mode.empty": "Empty structure",
  "paste.mode.emptyHint": "Same blocks and nesting with titles, without content or links.",
  "paste.mode.mirror": "Mirror",
  "paste.mode.mirrorHint": "Shows the originals live: editing either changes both.",
  "paste.paste": "Paste",
  "paste.pasting": "Pasting…",
  "paste.refuse.block": "A block cannot be mirrored inside itself.",
  "paste.refuse.missing": "An original is no longer on its page.",
  "paste.refuse.page": "A page cannot mirror itself.",
  "paste.title.afterBlock": "Paste after this block",
  "paste.title.afterSelection": "Paste after the selection",
  "paste.title.atEnd": "Paste at the end of the page",
  "paste.title.intoGroup": "Paste into this group",
  "paste.whatBlocks": {
    "one": "{count} block from “{title}”",
    "other": "{count} blocks from “{title}”"
  },
  "paste.whatPage": {
    "one": "all {count} block of “{title}”",
    "other": "all {count} blocks of “{title}”"
  },
  "rail.addQuery": "Add from query…",
  "rail.arrow": "Arrow",
  "rail.arrow.both": "both ends",
  "rail.arrow.none": "none",
  "rail.arrow.target": "at target",
  "rail.button": "Relations",
  "rail.cached": "cached result (offline)",
  "rail.closeStyle": "Close style editor",
  "rail.colour": "Colour",
  "rail.dash.dashdot": "dash-dot",
  "rail.dash.dashed": "dashed",
  "rail.dash.dotted": "dotted",
  "rail.dash.solid": "solid",
  "rail.defaultStyle": "default",
  "rail.dialog.add": "Add a query track",
  "rail.dialog.edit": "Edit query track",
  "rail.dialog.intro": "Each result row draws one connector: <b>?source</b> and <b>?target</b> must be blocks of this page; <b>?label</b> is optional. Results are cached, so the track still draws offline.",
  "rail.editStyle": "Edit style",
  "rail.elsewhere": "{count} elsewhere, not drawn",
  "rail.line": "Line",
  "rail.newStyle": "New style…",
  "rail.none": "No block-to-block links on this page yet.",
  "rail.offPage": {
    "one": "{count} link goes to blocks on other pages and is not drawn.",
    "other": "{count} links go to blocks on other pages and are not drawn."
  },
  "rail.offPageCount": "{count} off-page",
  "rail.onPage": "Relations on this page",
  "rail.query": "Query",
  "rail.queryFailed": "Query failed: {error}",
  "rail.queryTracks": "Query tracks",
  "rail.rerun": "re-run",
  "rail.retry": "retry",
  "rail.rowsOnPage": {
    "one": "{count} row on this page",
    "other": "{count} rows on this page"
  },
  "rail.show": "Show relation rail",
  "rail.showLabel": "label",
  "rail.showPredicate": "Show {label}",
  "rail.side": "Side",
  "rail.side.left": "left",
  "rail.side.right": "right",
  "rail.style": "Style",
  "rail.styleScope": "— used by every page of this workspace",
  "rail.width": "Width",
  "rail.ws.blockLinks": "Also show links between the pages' blocks, counted",
  "rail.ws.offTree": {
    "one": "{count} link goes to a page that is not in the tree and is not drawn.",
    "other": "{count} links go to pages that are not in the tree and are not drawn."
  },
  "reaction.addAgent": "Add agent",
  "reaction.addCondition": "Add condition",
  "reaction.addQuantity": "Add quantity",
  "reaction.agents": "Agents",
  "reaction.coefficients": "Coefficients",
  "reaction.conditions": "Conditions",
  "reaction.drawFirst": "Draw the reaction first.",
  "reaction.drawnCount": "Empty: use the drawn count",
  "reaction.empty": "No reaction yet.",
  "reaction.emptyEdit": "No reaction yet — click Edit to draw one.",
  "reaction.kind": "Kind",
  "reaction.label": "reaction",
  "reaction.note": "Note",
  "reaction.quantities": "Quantities",
  "reaction.role.catalyst": "catalyst",
  "reaction.role.reagent": "reagent",
  "reaction.role.solvent": "solvent",
  "reaction.species": "Species (ChEBI)",
  "reaction.type": "Reaction type",
  "reaction.typePlaceholder": "Named reaction (RXNO)",
  "reaction.unit": "Unit",
  "reaction.value": "Value",
  "restrict.body": "A restricted member can still <b>read</b> this page: reading is workspace-wide. Content that some members must not read belongs in a separate workspace. A member editing the page now will be disconnected from it.",
  "restrict.dialog": "Restrict writing",
  "restrict.heading": "Restrict writing on “{title}”",
  "restrict.onlyViewers": "Only viewers here; they cannot write anyway.",
  "results.showing": "Showing {shown} of {total} rows.",
  "review.conflict.empty": "(empty)",
  "review.conflict.peer": "peer {peer}",
  "review.conflict.title": "Conflicting edits to <b>{key}</b>",
  "review.conflict.use": "Use this version",
  "review.dangling.deleted": "The target was deleted; restore it, or remove the link from its block.",
  "review.dangling.from": "From",
  "review.dangling.missing": "The target is missing; it may come back through undo or a restore, and this item then resolves itself.",
  "review.dangling.title": "A link points at something that is gone",
  "review.dangling.to": "to",
  "review.deprecated.apply": "Apply replacement",
  "review.deprecated.auto": {
    "one": "Replaced automatically in {count} place.",
    "other": "Replaced automatically in {count} places."
  },
  "review.deprecated.noReplacement": "The ontology names no replacement; relink manually.",
  "review.deprecated.notAuto": "Not replaced automatically: {reason}",
  "review.deprecated.reason.auto_off": "automatic replacement is off for this workspace.",
  "review.deprecated.reason.breaks_shape": "the replacement would break a rule (SHACL) where the term is used.",
  "review.deprecated.reason.chain_too_long": "the chain of replacements is too long.",
  "review.deprecated.reason.cycle": "the replacements lead back to each other.",
  "review.deprecated.reason.kind_mismatch": "the replacement is a different kind of term (for example a relation instead of a class).",
  "review.deprecated.reason.no_replacement": "the ontology names no replacement.",
  "review.deprecated.reason.not_imported": "the replacement is not imported yet; an administrator adds it to the ontology's term file.",
  "review.deprecated.reason.several_replacements": "the ontology names more than one replacement.",
  "review.deprecated.replacement": "Replacement:",
  "review.deprecated.revert": "Revert",
  "review.deprecated.reverted": "Reverted: the old term is back where the replacement was.",
  "review.deprecated.usedBy": {
    "one": "is deprecated · used in {count} document",
    "other": "is deprecated · used in {count} documents"
  },
  "review.dismiss": "Dismiss",
  "review.edge.confidence": "confidence {value}",
  "review.edge.derived": "derived",
  "review.edge.promote": "Promote",
  "review.edge.reject": "Reject",
  "review.empty": "Nothing to review.",
  "review.fact.about": "about {term}",
  "review.fact.promote": "Add as fact",
  "review.factUnit.ambiguous": "This could be more than one unit. Choose the one the text means.",
  "review.factUnit.unknown": "KSS knows no unit written like this for this quantity. Choose the one the text means, or dismiss it.",
  "review.grounding.best": "best score {score}",
  "review.grounding.choose": "Choose",
  "review.grounding.conceptLabel": "Concept label",
  "review.grounding.createConcept": "Create concept",
  "review.grounding.in": "in",
  "review.grounding.noMatch": "no close match",
  "review.grounding.suggested": "suggested type: {type}",
  "review.grounding.typeTitle": "The type the model suggested; it only narrows the candidate search and is not recorded",
  "review.kind.dangling_link": "Dangling links",
  "review.kind.deprecated_term": "Deprecated terms",
  "review.kind.derived_edge": "Derived edges",
  "review.kind.fact_unit": "Units to choose",
  "review.kind.grounding": "Grounding",
  "review.kind.lww_conflict": "Conflicts",
  "review.kind.shacl_violation": "SHACL",
  "review.loadError": "Could not load review items (online only).",
  "review.openBlock": "open block",
  "review.shacl.default": "SHACL violation",
  "review.shacl.focus": "Focus node:",
  "review.shacl.path": "path",
  "review.shacl.value": "value",
  "review.status.dismissed": "Dismissed",
  "review.status.open": "Open",
  "review.status.resolved": "Resolved",
  "review.title": "Review",
  "role.editor": "editor",
  "role.intro": "A role says what the block <b>is</b> — an issue, a position, a step. Several are allowed.",
  "role.offline": "Offline — the role list needs the server.",
  "role.owner": "owner",
  "role.search": "Search roles…",
  "role.title": "What is this block?",
  "role.viewer": "viewer",
  "section.empty": "Empty section",
  "section.mode.markdown": "Markdown",
  "section.mode.rendered": "Rendered",
  "section.mode.wysiwym": "WYSIWYM",
  "section.viewMode": "View mode",
  "seq.block": "block {id}",
  "seq.create": "Create sequence",
  "seq.delete": "Delete sequence",
  "seq.empty": "No sequences yet.",
  "seq.hint": "Add blocks from a block menu.",
  "seq.moveDown": "Move down",
  "seq.moveUp": "Move up",
  "seq.name": "Sequence name",
  "seq.new": "New sequence",
  "seq.title": "Sequences",
  "seq.untitled": "(untitled)",
  "server.adminsOnly": "This page is for administrators.",
  "server.choice.KM_RAIL_BUNDLE_GROUPS.bundle": "bundled",
  "server.choice.KM_RAIL_BUNDLE_GROUPS.separate": "separate lines with a brace",
  "server.choice.KM_RAIL_BUNDLE_OVERLAP.larger": "the larger bundle",
  "server.choice.KM_RAIL_BUNDLE_OVERLAP.origin": "always the origin bundle",
  "server.discard": "Discard",
  "server.environment": "Environment",
  "server.environment.sub": "Set in .env and read at start. Changing these needs a restart of the server.",
  "server.error.choice": "Choose one of the offered values.",
  "server.error.host": "{host} is not on the server's list of allowed model hosts (KM_LLM_ALLOWED_HOSTS in .env).",
  "server.error.integer": "Enter a whole number.",
  "server.error.length": "This is too long; at most {max} characters.",
  "server.error.password": "The password is too weak.",
  "server.error.range": "Enter a value from {min} to {max}.",
  "server.error.required": "This cannot be empty.",
  "server.error.type": "This is not the right kind of value.",
  "server.error.unknown": "This setting cannot be changed here.",
  "server.error.url": "Enter an http or https address.",
  "server.group.decision": "Decision model",
  "server.group.decision.sub": "An optional second model that picks between grounding candidates.",
  "server.group.extraction": "Extraction",
  "server.group.extraction.sub": "How much of a page and its files one extraction reads.",
  "server.group.graph": "Graph queries",
  "server.group.graph.sub": "Limits for queries against the knowledge graph.",
  "server.group.llm": "Language model",
  "server.group.llm.sub": "The model that extracts entities and relations from pages.",
  "server.group.mcp": "MCP connector",
  "server.group.mcp.sub": "AI assistants that work with KSS through people's tokens.",
  "server.group.rail": "Relation rail",
  "server.group.rail.sub": "How the relation rail beside pages draws connectors that share an end.",
  "server.group.sessions": "Sessions",
  "server.group.sessions.sub": "Connections of open pages to the sync server.",
  "server.group.signin": "Sign-in",
  "server.group.signin.sub": "How people sign in.",
  "server.group.transfer": "Page archives",
  "server.group.transfer.sub": "Exporting and importing pages.",
  "server.group.web": "Web pages",
  "server.group.web.sub": "Browsing and freezing web pages in web page blocks.",
  "server.hidden": "The environment sets {value}; the value saved here replaces it.",
  "server.history": "History",
  "server.history.command": "A server command",
  "server.history.empty": "(empty)",
  "server.history.mcp.token_created": "created the MCP token “{user}”.",
  "server.history.mcp.token_revoked": "revoked the MCP token “{user}”.",
  "server.history.mcp.tokens_revoked": "revoked every MCP token of {user}.",
  "server.history.mcp.write": "changed {user} through the MCP connector.",
  "server.history.more": "Show older",
  "server.history.none": "Nothing has been changed yet.",
  "server.history.setting.reset": "reset {setting} from {before} to {after}.",
  "server.history.setting.saved": "changed {setting} from {before} to {after}.",
  "server.history.sub": "Every change made on this page, newest first. Keys are recorded as changed, never their value.",
  "server.history.user.active.off": "deactivated {user}.",
  "server.history.user.active.on": "reactivated {user}.",
  "server.history.user.admin.off": "removed {user}'s administrator rights.",
  "server.history.user.admin.on": "made {user} an administrator.",
  "server.history.user.created": "created the user {user}.",
  "server.history.user.edited": "changed the {fields} of {user}.",
  "server.history.user.password": "set a new password for {user}.",
  "server.link": "Server settings",
  "server.needServer": "This needs the server.",
  "server.reset": "Reset",
  "server.save": "Save",
  "server.saved": "Saved.",
  "server.secret.clear": "Clear",
  "server.secret.new": "New key",
  "server.secret.notSet": "not set",
  "server.secret.replace": "Replace…",
  "server.secret.set": "set",
  "server.secret.unreadable": "The saved key can no longer be read, probably because the server's secret key changed. Enter it again.",
  "server.setting.KM_AUTO_EXTRACT": "Extract automatically",
  "server.setting.KM_AUTO_EXTRACT.help": "Extract a page in the background after it changes, in workspaces that do not decide otherwise.",
  "server.setting.KM_DECISION_ACCEPT": "Accept at",
  "server.setting.KM_DECISION_ACCEPT.help": "A decision at least this sure grounds the entity without review.",
  "server.setting.KM_DECISION_ACCEPT_LOGPROBS": "Accept at (logprobs)",
  "server.setting.KM_DECISION_ACCEPT_LOGPROBS.help": "The same for the logprobs protocol, whose certainty is not calibrated. 1.1 never accepts.",
  "server.setting.KM_DECISION_BASE_URL": "Address",
  "server.setting.KM_DECISION_BASE_URL.help": "The server's address without /v1, for example http://ollama:11434. Empty switches the decision model off.",
  "server.setting.KM_DECISION_COOLDOWN_S": "Pause after a failure",
  "server.setting.KM_DECISION_COOLDOWN_S.help": "How long to stop asking an endpoint that failed.",
  "server.setting.KM_DECISION_MODEL": "Model",
  "server.setting.KM_DECISION_MODEL.help": "The decision model's name.",
  "server.setting.KM_DECISION_PROTOCOL": "Protocol",
  "server.setting.KM_DECISION_PROTOCOL.help": "systemone for an Ollama decision endpoint, logprobs for any chat model, auto to try both.",
  "server.setting.KM_DECISION_TIMEOUT": "Timeout",
  "server.setting.KM_DECISION_TIMEOUT.help": "How long to wait for an answer, including loading the model.",
  "server.setting.KM_EXTRACTION_MAX_NODES": "Blocks per run",
  "server.setting.KM_EXTRACTION_MAX_NODES.help": "The most blocks one extraction run reads.",
  "server.setting.KM_FILE_PROMPT_MAX_BYTES": "File text per prompt",
  "server.setting.KM_FILE_PROMPT_MAX_BYTES.help": "How much of that text one prompt receives. Small local models need little.",
  "server.setting.KM_FILE_TEXT_MAX_BYTES": "Text kept per file",
  "server.setting.KM_FILE_TEXT_MAX_BYTES.help": "How much text is kept from an attached file.",
  "server.setting.KM_GRAPH_MAX_ROWS": "Rows per query",
  "server.setting.KM_GRAPH_MAX_ROWS.help": "The most rows one query returns.",
  "server.setting.KM_GRAPH_TIMEOUT_S": "Query timeout",
  "server.setting.KM_GRAPH_TIMEOUT_S.help": "How long one query may run.",
  "server.setting.KM_LLM_API_KEY": "API key",
  "server.setting.KM_LLM_API_KEY.help": "Sent as a bearer token. It is never shown again once saved.",
  "server.setting.KM_LLM_BASE_URL": "Address",
  "server.setting.KM_LLM_BASE_URL.help": "The model's OpenAI-compatible address, ending in /v1. Only hosts on the server's allowed list are accepted.",
  "server.setting.KM_LLM_MODEL": "Model",
  "server.setting.KM_LLM_MODEL.help": "The model's name as the endpoint knows it.",
  "server.setting.KM_MCP_ENABLED": "Connector on",
  "server.setting.KM_MCP_ENABLED.help": "Off refuses every token at once, and nobody can create new ones.",
  "server.setting.KM_MCP_INLINE_MAX_BYTES": "Largest upload in a call",
  "server.setting.KM_MCP_INLINE_MAX_BYTES.help": "Files up to this size may be sent within a tool call; larger ones use an upload address.",
  "server.setting.KM_MCP_MAX_TOKENS": "Tokens per person",
  "server.setting.KM_MCP_MAX_TOKENS.help": "The most valid tokens one person may hold.",
  "server.setting.KM_MCP_RATE_LIMIT": "Calls per minute",
  "server.setting.KM_MCP_RATE_LIMIT.help": "The most tool calls one token may make in a minute.",
  "server.setting.KM_OIDC_LABEL": "Keycloak button label",
  "server.setting.KM_OIDC_LABEL.help": "The name on the sign-in button for Keycloak.",
  "server.setting.KM_OIDC_REQUIRED_GROUP": "Required Keycloak group",
  "server.setting.KM_OIDC_REQUIRED_GROUP.help": "Only members of this group may sign in through Keycloak. Empty lets everyone in the realm.",
  "server.setting.KM_PASSWORD_LOGIN": "Password sign-in",
  "server.setting.KM_PASSWORD_LOGIN.help": "Off leaves only Keycloak sign-in. Administrators can always sign in with a password.",
  "server.setting.KM_RAIL_BUNDLE_GROUPS": "Option groups",
  "server.setting.KM_RAIL_BUNDLE_GROUPS.help": "Whether the connectors of an option group run along one trunk, with the group's label on it.",
  "server.setting.KM_RAIL_BUNDLE_OVERLAP": "Connector in two bundles",
  "server.setting.KM_RAIL_BUNDLE_OVERLAP.help": "A connector that shares its origin with some and its target with others joins one bundle.",
  "server.setting.KM_SYNC_TOKEN_TTL_S": "Sync token lifetime",
  "server.setting.KM_SYNC_TOKEN_TTL_S.help": "How long a page's sync token is valid. A shorter one ends a removed member's access sooner.",
  "server.setting.KM_TRANSFER_MAX_BYTES": "Archive size",
  "server.setting.KM_TRANSFER_MAX_BYTES.help": "The largest page archive that can be imported.",
  "server.setting.KM_TRANSFER_TTL_S": "Archives kept for",
  "server.setting.KM_TRANSFER_TTL_S.help": "Exported and imported archives are deleted after this.",
  "server.setting.KM_WEB_BROWSING": "Web browsing",
  "server.setting.KM_WEB_BROWSING.help": "Off stops all browsing in web page blocks; frozen snapshots stay readable.",
  "server.setting.KM_WEB_DOM_MAX_BYTES": "Page text size",
  "server.setting.KM_WEB_DOM_MAX_BYTES.help": "The largest page text kept with a snapshot.",
  "server.setting.KM_WEB_RECORD_MAX_BYTES": "Recording size",
  "server.setting.KM_WEB_RECORD_MAX_BYTES.help": "The most one browsing session may record.",
  "server.setting.KM_WEB_SESSION_TTL_S": "Browsing session lifetime",
  "server.setting.KM_WEB_SESSION_TTL_S.help": "Recordings of older sessions are deleted; snapshots are kept.",
  "server.setting.KM_WEB_SNAPSHOT_MAX_BYTES": "Snapshot size",
  "server.setting.KM_WEB_SNAPSHOT_MAX_BYTES.help": "The largest frozen snapshot.",
  "server.setting.KM_WEB_TOKEN_IDLE_S": "Idle browsing ends after",
  "server.setting.KM_WEB_TOKEN_IDLE_S.help": "A browsing session unused this long stops working.",
  "server.source.default": "default",
  "server.source.environment": "environment",
  "server.source.saved": "saved here",
  "server.tab.history": "History",
  "server.tab.settings": "Settings",
  "server.tab.users": "Users",
  "server.test": "Test connection",
  "server.test.answered": "{model} answered in {ms} ms.",
  "server.test.format": "{model} answered in {ms} ms, but not in the requested format. Extraction still validates every answer.",
  "server.test.host": "{message} is not on the server's list of allowed model hosts.",
  "server.test.http": "The endpoint answered with an error: {message}",
  "server.test.model_missing": "Reached, but the endpoint does not offer {model}. It offers: {message}",
  "server.test.patience": "A model that is not loaded yet can take a minute or two.",
  "server.test.reached": "Reached in {ms} ms; {model} is available.",
  "server.test.running": "Testing…",
  "server.test.timeout": "No answer within {message} s. The model may still be loading; try again in a minute.",
  "server.test.unparseable": "The endpoint answered something that is not JSON.",
  "server.test.unreachable": "Not reachable: {message}",
  "server.test.url": "Enter an http or https address first.",
  "server.title": "Server settings",
  "server.users": "Users",
  "server.users.admin": "Administrator",
  "server.users.col.lastLogin": "Last sign-in",
  "server.users.col.signIn": "Signs in with",
  "server.users.col.user": "User",
  "server.users.col.workspaces": "Workspaces",
  "server.users.create": "Create user",
  "server.users.deactivate": "Deactivate",
  "server.users.displayName": "Display name",
  "server.users.edit": "Edit…",
  "server.users.editTitle": "Edit {user}",
  "server.users.email": "E-mail",
  "server.users.field.displayName": "display name",
  "server.users.field.email": "e-mail",
  "server.users.guard.lastAdmin": "The last administrator stays.",
  "server.users.guard.oidc": "This account's password is kept in Keycloak.",
  "server.users.guard.self": "Not for your own account.",
  "server.users.inactive": "deactivated",
  "server.users.isAdmin": "Administrator: may open the server settings",
  "server.users.makeAdmin": "Make administrator",
  "server.users.mcpTokens": {
    "one": "{count} MCP token",
    "other": "{count} MCP tokens"
  },
  "server.users.menu": "Actions for {user}",
  "server.users.never": "never",
  "server.users.new": "New user",
  "server.users.newPassword": "New password",
  "server.users.password": "Set password…",
  "server.users.passwordTitle": "New password for {user}",
  "server.users.reactivate": "Reactivate",
  "server.users.refused.last_admin": "The server needs at least one active administrator.",
  "server.users.refused.oidc": "This account signs in with Keycloak; its password is kept there.",
  "server.users.refused.self": "You cannot do that to your own account.",
  "server.users.refused.system": "System accounts cannot be changed.",
  "server.users.refused.username_taken": "This username is taken.",
  "server.users.removeAdmin": "Remove administrator",
  "server.users.revokeTokens": "Revoke all MCP tokens",
  "server.users.setPassword": "Set password",
  "server.users.signIn.oidc": "Keycloak",
  "server.users.signIn.password": "password",
  "server.users.sub": "Every account on this server. Memberships are set on each workspace's settings page.",
  "settings.confirm": "Confirm",
  "settings.confirm.allow": "Allow",
  "settings.confirm.auto.body": "Every ten minutes, out-of-date blocks will be sent to <b>{host}</b>{model} without anyone asking. This costs whatever that endpoint costs.",
  "settings.confirm.auto.title": "Extract automatically?",
  "settings.confirm.egress.body": "Extraction will be allowed to send the text of this workspace's pages to <b>{host}</b>{model}{notListed}. It stays off for every other workspace.",
  "settings.confirm.egress.title": "Allow page text to leave this machine?",
  "settings.confirm.notListed": ", which is not on the server's allow-list",
  "settings.delete.body": "Deleting hides the workspace from every member at once and disconnects anyone who has it open. Its pages, their history and their files are kept, so a server administrator can restore it. Single pages are deleted from the page itself and restored from the workspace's trash.",
  "settings.delete.button": "Delete workspace…",
  "settings.delete.confirm.body": "Every member loses access to <b>{name}</b> and its pages at once. Type the workspace's name to confirm.",
  "settings.delete.confirm.label": "Workspace name",
  "settings.delete.confirm.ok": "Delete workspace",
  "settings.delete.confirm.title": "Delete “{name}”?",
  "settings.delete.ownerOnly": "Only an owner can delete this workspace.",
  "settings.delete.title": "Deleting this workspace",
  "settings.members": "Members",
  "settings.members.add": "Add",
  "settings.members.already": "This person is already a member.",
  "settings.members.ambiguous": "Several people have this name. Use their username or e-mail address.",
  "settings.members.keycloak": "Keycloak: {name}",
  "settings.members.needServer": "Members need the server.",
  "settings.members.newRole": "Role of the new member",
  "settings.members.notFound": "No account has this username, e-mail address, Keycloak login or name.",
  "settings.members.oidc": "Keycloak decides membership for this workspace: changes made here are overwritten at the member's next sign-in. The last owner is kept and marked <b>manual</b>.",
  "settings.members.remove": "Remove {user}",
  "settings.members.roleOf": "Role of {user}",
  "settings.members.sub": "Read access is workspace-wide: every member can read every page.",
  "settings.members.who": "Username, e-mail or name",
  "settings.members.you": "(you)",
  "settings.name": "Name",
  "settings.policy": "Policy",
  "settings.policy.auto": "Automatic extraction",
  "settings.policy.auto.body": "Every ten minutes, blocks whose extraction is out of date are sent to the LLM again. Attachments are never swept. The server default is {state}.",
  "settings.policy.egress": "LLM egress",
  "settings.policy.egress.body": "Extraction may use an endpoint outside the server's allow-list. Page text then leaves this machine for {host}{model}.",
  "settings.policy.endpoint": "the configured endpoint",
  "settings.policy.mcp": "MCP connectors",
  "settings.policy.mcp.body": "AI assistants connected through a member's MCP token may read this workspace and, with write rights, change it. Off, tokens see nothing of it.",
  "settings.policy.migrate": "Replace outdated ontology terms automatically",
  "settings.policy.migrate.body": "When an ontology retires a term and names exactly one safe successor, KSS replaces it in every page by itself. Each replacement appears in the review inbox, where it can be reverted. Anything less clear stays a question for a person.",
  "settings.policy.off": "off",
  "settings.policy.on": "on",
  "settings.policy.serverDefault": "server default",
  "settings.policy.web": "Web browsing",
  "settings.policy.web.body": "Web page blocks may browse live pages through the recording proxy. Frozen snapshots are shown either way.",
  "settings.readOnly": "You can see this workspace's settings; an owner can change them.",
  "settings.rename": "Rename",
  "settings.restricted": "Pages with restricted writing",
  "settings.restricted.forYou": "read-only for you",
  "settings.restricted.none": "No page restricts writing.",
  "settings.restricted.sub": "A page's write restrictions are set on the page itself, under “Restrict writing…”.",
  "settings.title": "Settings",
  "sync.connecting": "connecting…",
  "sync.error": "sync error",
  "sync.forbidden": "no access",
  "sync.offline": "offline",
  "sync.synced": "synced",
  "sync.syncing": "syncing…",
  "table.align.center": "Centre",
  "table.align.left": "Align left",
  "table.align.right": "Align right",
  "table.caption": "Caption (optional)",
  "table.colLeft": "Add a column to the left",
  "table.colRight": "Add a column to the right",
  "table.copied": "Copied",
  "table.copy": "Copy as Markdown",
  "table.deleteColumn": "Delete the column",
  "table.deleteRow": "Delete the row",
  "table.rowAbove": "Add a row above",
  "table.rowBelow": "Add a row below",
  "tb.bold": "Bold (Ctrl/⌘+B)",
  "tb.bullet": "Bullet list",
  "tb.code": "Inline code (Ctrl/⌘+`)",
  "tb.formatting": "Formatting",
  "tb.heading": "Heading {level}",
  "tb.indent": "Indent list item",
  "tb.italic": "Italic (Ctrl/⌘+I)",
  "tb.link": "Link",
  "tb.linkInvalid": "Only http, https and mailto links are allowed.",
  "tb.linkPrompt": "Link URL (https://…)",
  "tb.linkPromptEdit": "Link URL (empty removes the link)",
  "tb.ordered": "Numbered list",
  "tb.outdent": "Outdent list item",
  "tb.paragraph": "Paragraph",
  "tb.quote": "Quote",
  "tb.redo": "Redo",
  "tb.rule": "Horizontal rule",
  "tb.strike": "Strikethrough",
  "tb.undo": "Undo",
  "termPicker.free": "not an ontology term",
  "trash.deletedOn": "deleted {date}",
  "trash.restore": "Restore",
  "trash.title": "Trash ({count})",
  "tree.collapse": "Collapse folder",
  "tree.copyFolderIri": "Copy folder IRI",
  "tree.copyPageIri": "Copy page IRI",
  "tree.deleteFolder": "Delete folder",
  "tree.dissolve": "Dissolve folder",
  "tree.dragFolder": "Drag folder",
  "tree.dragPage": "Drag page",
  "tree.expand": "Expand folder",
  "tree.folderTitle": "Folder name",
  "tree.intoFolderAbove": "Move into folder above",
  "tree.items": {
    "one": "{count} item",
    "other": "{count} items"
  },
  "tree.menu": "Page menu",
  "tree.newFolder": "New folder",
  "tree.newFolderHere": "New folder here",
  "tree.newFolderTitle": "New folder",
  "tree.newPageHere": "New page here",
  "tree.outOfFolder": "Move out of folder",
  "urlBlock.action.browser": "open in the browser",
  "urlBlock.action.copy": "copy the link",
  "urlBlock.action.system": "open with the system app",
  "urlBlock.address": "Address",
  "urlBlock.caption": "Text shown as the link (optional)",
  "urlBlock.copied": "Link copied",
  "urlBlock.empty": "no address",
  "urlBlock.hint": "Type or paste an address below.",
  "urlBlock.noScheme": "add a scheme such as https://",
  "urlBlock.none": "No address yet.",
  "urlBlock.refused": "{scheme}: links are not allowed",
  "urlBlock.systemHint": "for app links such as mailto: or zotero:; a web address opens in the browser",
  "urlBlock.whenClicked": "When clicked",
  "video.badUrl": "Not a valid http(s) URL",
  "video.frame": "Video",
  "video.load": "▶ Load {provider} player ({id})",
  "video.placeholder": "Paste a YouTube, Vimeo or other video URL",
  "web.back": "Back",
  "web.badAddress": "Enter an http(s) address.",
  "web.cannotOpen": "The web page cannot be opened right now.",
  "web.empty": "No web page yet.",
  "web.emptyEdit": "Type an address above and press Enter.",
  "web.forward": "Forward",
  "web.freeze": "Freeze",
  "web.freezeFailed": "Freeze failed.",
  "web.freezeFailedWith": "Freeze failed: {error}",
  "web.freezeTitle": "Keep this page exactly as it is now",
  "web.freezing": "Freezing…",
  "web.frozenAt": "frozen {date}",
  "web.noAddress": "No address yet",
  "web.noAnswer": "The page did not answer. Reload it and try again.",
  "web.offline": "Not available offline — only frozen pages are.",
  "web.reload": "Reload",
  "web.replay": "Replay original",
  "web.replayTitle": "Re-run the recorded page with its scripts instead of showing the page as it was frozen",
  "web.showSnapshot": "Show this snapshot",
  "web.shown": "shown",
  "web.snapshotOffline": "This snapshot is not available offline. Pin the page to keep it.",
  "web.snapshots": {
    "one": "{count} snapshot",
    "other": "{count} snapshots"
  },
  "web.unfreeze": "Unfreeze",
  "web.usePage": "Use this page",
  "workspace.gone.body": "An owner deleted it, so its pages can no longer be opened or edited. Ask the owner or your server administrator if it should come back.",
  "workspace.gone.home": "Back to your workspaces",
  "workspace.gone.title": "This workspace was deleted",
  "ws.createPage": "Create page",
  "ws.fallbackName": "Workspace",
  "ws.list.create": "Create",
  "ws.list.deleted": "“{name}” was deleted.",
  "ws.list.deleted.undo": "Undo",
  "ws.list.empty": "No workspaces yet.",
  "ws.list.lead": "Every page, link and fact lives in one of these.",
  "ws.list.newName": "New workspace name",
  "ws.list.title": "Workspaces",
  "ws.nav.graph": "Graph",
  "ws.nav.review": "Review",
  "ws.nav.settings": "Settings",
  "ws.newPageTitle": "New page title",
  "ws.noPages": "No pages yet.",
  "ws.notInTree": "(not in page tree)",
  "ws.readOnly": "read-only"
}
